import { CompositeView, GridView, SimpleView } from '@digital/ui';
import React from 'react';


const RelatorioDashboard = () => {
  return (
    <CompositeView>
      <SimpleView>
        <GridView id="relatorio" noform icon="commons-document">
          <iframe
            title="PowerBI"
            width="100%"
            style={{ height: 'calc(100vh - 120px)' }}
            src="https://app.powerbi.com/view?r=eyJrIjoiYWQ4ZGViYzMtNTQ1MC00YjgwLTgxMTktZThjOWQyNmM5YjdmIiwidCI6ImY0NzI3MGEwLWQzYzctNDA4Ny05YTRjLWI0ZDgyOWQwYjI0MyJ9"
            frameBorder="0"
            allowFullScreen
          />
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};
export default RelatorioDashboard;
